import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { AlertType } from '@nft-folks/interfaces';
import { CreateHotToastRef, HotToastService } from '@ngneat/hot-toast';
import { ToastOptions } from '@ngneat/hot-toast/lib/hot-toast.model';
import {
  NotificationDataType,
  NotificationToastComponent,
} from '../../shared/components/notification-toast/notification-toast.component';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  refs: Record<string, CreateHotToastRef<any>[]> = {};
  closeAllRef: CreateHotToastRef<any> | null = null;

  constructor(private translateService: TranslocoService, private toastrService: HotToastService) {}

  info(
    message: string,
    translateContext = 'alert.info',
    options?: Partial<ToastOptions<any>>,
  ): CreateHotToastRef<any> {
    return this.showAlert(message, AlertType.INFO, translateContext, options);
  }

  success(
    message: string,
    translateContext = 'alert.success',
    options?: Partial<ToastOptions<any>>,
  ): CreateHotToastRef<any> {
    return this.showAlert(message, AlertType.SUCCESS, translateContext, options);
  }

  error(
    message: string,
    translateContext = 'alert.error',
    options?: Partial<ToastOptions<any>>,
  ): CreateHotToastRef<any> {
    return this.showAlert(message, AlertType.ERROR, translateContext, options);
  }

  warning(
    message: string,
    translateContext = 'alert.warning',
    options?: Partial<ToastOptions<any>>,
  ): CreateHotToastRef<any> {
    return this.showAlert(message, AlertType.WARNING, translateContext, options);
  }

  clearAll() {
    Object.entries(this.refs).forEach(([key, value]) => {
      value.forEach((ref) => ref.close());
    });
    this.refs = {};
    this.closeAllRef = null;
  }

  private showAlert(
    message: string,
    type: AlertType,
    translateContext: string,
    options?: Partial<ToastOptions<any>>,
  ) {
    const id = message.toString().toLowerCase().trim();
    options = {
      autoClose: false,
      position: 'bottom-left',
      className: type.toString().toLowerCase(),
      ...options,
      id,
    };
    const toastRef = this.showToast(message, type, translateContext, options);
    return toastRef;
  }

  private showToast(
    message: string,
    type: AlertType,
    translateContext: string,
    options?: Partial<ToastOptions<any>>,
  ): CreateHotToastRef<any> {
    const data: NotificationDataType = {
      message: translateContext ? `${translateContext}.${message}` : message,
      alertType: type,
    };
    options = { ...options, data };

    switch (type) {
      case AlertType.SUCCESS:
        return this.toastrService.success(NotificationToastComponent, options);
        break;
      case AlertType.WARNING:
        return this.toastrService.warning(NotificationToastComponent, options);
        break;
      case AlertType.ERROR:
        return this.toastrService.error(NotificationToastComponent, options);
        break;
      case AlertType.INFO:
        return this.toastrService.info(NotificationToastComponent, options);
        break;
    }
  }
}
